"use strict";

require("core-js/modules/es.array.index-of.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openUrlInApp = exports.createKidH5Url = exports.openUrlInKidApp = exports.openUrl = void 0;

var vft_atom_1 = __importDefault(require("@tencent/vft-atom"));

var env_1 = __importDefault(require("@tencent/vft-common/env"));

var util_1 = require("@tencent/vft-common/util");

var url_1 = require("@tencent/vft-common/url");

var open_app_1 = require("./open-app");

var openapp_1 = __importDefault(require("@tencent/vft-common/openapp"));

var config_1 = __importDefault(require("@tencent/vft-common/openapp/config"));

function openUrl(url) {
  var newUrl = url; // 活动链接添加ptag

  if (newUrl.indexOf('http') === 0) {
    var ptag = util_1.getUrlParam('ptag', newUrl) || util_1.getUrlParam('ptag') || '';
    newUrl = util_1.setUrlParam('ptag', ptag, newUrl);
  }

  if (env_1.default.isKidApp) {
    openUrlInKidApp(newUrl);
    return;
  }

  if (env_1.default.isApp) {
    openUrlInApp(newUrl);
    return;
  }

  if (newUrl.indexOf('qqlivekid') === 0) {
    open_app_1.openKidApp(newUrl);
    return;
  }

  if (newUrl.indexOf('txvideo') === 0 || newUrl.indexOf('tenvideo2') === 0) {
    openapp_1.default.launch(newUrl);
    return;
  }

  location.href = newUrl;
}

exports.openUrl = openUrl; // 小企鹅app内打开链接 支持普通http链接&&腾讯视频伪协议

function openUrlInKidApp(url, jumpSource) {
  var newUrl = url;
  newUrl = newUrl.indexOf('//') === 0 ? window.location.protocol + url : url; // 腾讯视频伪协议单独处理

  if (newUrl.indexOf('txvideo') === 0 || newUrl.indexOf('tenvideo2') === 0) {
    if (vft_atom_1.default.getVersion().compare('5.6.2')) {
      vft_atom_1.default.invoke('isInstalled', {
        pkgName: 'com.tencent.qqlive',
        pkgUrl: 'tenvideo2://',
        appName: '腾讯视频'
      }).then(function (res) {
        if (res === null || res === void 0 ? void 0 : res.installed) {
          vft_atom_1.default.invoke('launch3rdApp', {
            pkgName: 'com.tencent.qqlive',
            pkgUrl: newUrl,
            appName: '腾讯视频'
          });
        } else {
          newUrl = config_1.default.download;
        }
      });
    } else {
      newUrl = "https://film.qq.com/h5/app/openapp.html?auto=1&openurl=" + window.encodeURIComponent(url);
    }
  }

  if (newUrl.indexOf('http') === 0) {
    var ptag = util_1.getUrlParam('ptag', newUrl) || util_1.getUrlParam('ptag') || '';
    newUrl = createKidH5Url({
      url: newUrl,
      jumpSource: jumpSource || ptag
    });
  }

  vft_atom_1.default.invoke('openView', {
    url: newUrl
  });
}

exports.openUrlInKidApp = openUrlInKidApp;

function createKidH5Url(urlConfig) {
  return createLinkUrl({
    t: urlConfig.title || '小企鹅乐园',
    ui: 'web',
    url: urlConfig.url,
    orientation: urlConfig.orientation || 'auto',
    jump_source: urlConfig.jumpSource || ''
  }, {
    xqe_data_mode: urlConfig.xqeDataMode || 1,
    login_mode: urlConfig.loginMode || 0,
    vip_mode: urlConfig.vipMode || 1
  });
}

exports.createKidH5Url = createKidH5Url;

function createLinkUrl(urlParam, ext) {
  var extParam = '';

  if (ext) {
    extParam = JSON.stringify(ext);
  }

  var finalParam = __assign({
    extParam: extParam
  }, urlParam);

  return url_1.buildUrl('qqlivekid://v.qq.com/JumpAction?', finalParam, true);
} // 腾讯视频内打开链接


function openUrlInApp(url) {
  var newUrl = url; // 拼接伪协议

  if (/^(http|https):\/\/(\S*\.qq\.com|(vurl\.vip))/.test(newUrl)) {
    newUrl = "txvideo://v.qq.com/HollywoodH5Activity?url=" + encodeURIComponent(newUrl);
  } else {
    if (/^(http|https):\/\//.test(newUrl)) {
      newUrl = "txvideo://v.qq.com/Html5Activity?url=" + encodeURIComponent(newUrl);
    }
  }

  vft_atom_1.default.invoke('openView', {
    url: newUrl
  });
}

exports.openUrlInApp = openUrlInApp;
exports.default = {
  openUrl: openUrl,
  openUrlInKidApp: openUrlInKidApp,
  createKidH5Url: createKidH5Url,
  openUrlInApp: openUrlInApp
};